<template>
    <footer class="footer-area section-gap">
        <div class="container">
            <div class="row">
                <div class="col-2 f-logo">
                    <img src="img/logo1.jpg" alt="Logo">
                </div>
                <div class="menu col-5">
                    <a href="index.html">Головна</a>
                    <a href="about.html">Про нас</a>
                    <a href="#services">Послуги</a>
                    <a href="#team">Працівники</a>
                </div>
                <div class="col-2 s-media">
                    <a href="https://www.facebook.com/vova.lebid.3">
                        <i class="fab fa-facebook-square"></i>
                    </a>
                    <a href="https://www.instagram.com/vova_lebiddd/">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a href="https://t.me/volodddymyr">
                        <i class="fab fa-telegram-plane"></i>
                    </a>
                </div>
                <div class="col-3 menu-tel">
                    <a href="tel:380993568581" class="tel">
                        <i class="fas fa-phone-alt"></i>
                        <p>+380 99 356 8581</p>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-1 ml-auto text-right">
                    <a href="#" class="arrow-up">
                        <i class="fas fa-angle-double-up"></i>
                    </a>
                </div>
            </div>
            <div class="row bottom">
                <div class="col-6">
                    <p class="copyright">© Copyright 2019. All rights reserved.</p>
                </div>
                <div class="col-6 ml-auto text-right">
                    <p class="author">Made by Behzod Xudoyberdiyev</p>
                    <p class="author">Design by Volodymyr Lebid</p>
                </div>
            </div>
        </div>
    </footer>

</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>
